function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.51074 4.57318L7.55806 21.106",
  stroke: "white",
  strokeWidth: 1.63395,
  strokeLinecap: "square",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.545 7.13696H8.45502C9.30477 7.13696 10 7.83302 10 8.68348C10 9.53393 9.30477 10.2305 8.45502 10.2305H6.545C5.69525 10.2305 5 9.53444 5 8.68348C5 7.83252 5.69525 7.13696 6.545 7.13696Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 1.22547,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5107 4.57318L17.5581 21.106",
  stroke: "white",
  strokeWidth: 1.63395,
  strokeLinecap: "square",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.545 7.13696H18.455C19.3048 7.13696 20 7.83302 20 8.68348C20 9.53393 19.3048 10.2305 18.455 10.2305H16.545C15.6953 10.2305 15 9.53444 15 8.68348C15 7.83252 15.6953 7.13696 16.545 7.13696Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 1.22547,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5107 4.16669L12.5581 20.6995",
  stroke: "white",
  strokeWidth: 1.63395,
  strokeLinecap: "square"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.545 14.9268H13.455C14.3048 14.9268 15 15.6228 15 16.4733C15 17.3237 14.3048 18.0203 13.455 18.0203H11.545C10.6953 18.0203 10 17.3242 10 16.4733C10 15.6223 10.6953 14.9268 11.545 14.9268Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 1.22547,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

function SvgMastering(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastering);
export default __webpack_public_path__ + "static/media/mastering.69ce38843eca434d456a0a175c506133281cd6de55a1975acea2de64550ec875.svg";
export { ForwardRef as ReactComponent };